module.exports = __webpack_public_path__ + "static/assets/10811a978de201353d564df7ba1ddb58.svg";